import { render, staticRenderFns } from "./ProductRequestPage.vue?vue&type=template&id=4a19e610&scoped=true&"
import script from "./ProductRequestPage.vue?vue&type=script&lang=js&"
export * from "./ProductRequestPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductRequestPage.vue?vue&type=style&index=0&id=4a19e610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a19e610",
  null
  
)

export default component.exports